import React from 'react'
import StickerGraphic from './StickerGraphic'
import { STICKER_OPTION_BY_ID } from '../../constants/stickerOptions'

const PRINT_POSITION_SCALE = 0.6
const PRINT_SIZE_SCALE = 1.7

export default function PrintSticker({ sticker }) {
  const option = STICKER_OPTION_BY_ID[sticker.type]
  if (!option) return null

  const position = typeof sticker?.position === 'object' ? sticker.position : { x: 0, y: 0 }
  const size = typeof sticker?.size === 'object' ? sticker.size : { height: 70, width: 70 }
  const rotation = Number.isFinite(sticker?.rotation) ? sticker.rotation : 0

  // Apply print scale factors
  const scaledX = position.x * PRINT_POSITION_SCALE
  const scaledY = position.y * PRINT_POSITION_SCALE
  const scaledWidth = size.width * PRINT_SIZE_SCALE
  const scaledHeight = size.height * PRINT_SIZE_SCALE

  return (
    <StickerGraphic
      src={option.src}
      alt={option.defaultLabel}
      height={scaledHeight}
      width={scaledWidth}
      x={scaledX}
      y={scaledY}
      rotation={rotation}
      zindex={sticker.zindex}
      data-testid="StickerGraphic"
    />
  )
}
